import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../styles/theme';
import { mediaQuery } from '../../../../styles/helpers';

const useStyles = createUseStyles(
  ({ spacing, breakpoints }: ITheme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
    examples: {
      marginTop: 30,
      textAlign: 'center',
    },
    description: {
      textAlign: 'center',
    },
    images: {
      marginTop: 8,
      display: 'flex',
      flexWrap: 'wrap',
      gap: spacing.small,
      cursor: 'pointer',
      justifyContent: 'center',

      '& > img': {
        width: 48,
        maxWidth: 48,
        height: 48,
        maxHeight: 48,

        borderRadius: '4px',
      },
    },
    cta: {
      padding: '11px 14px 12px 14px',
      lineHeight: '24px',
    },
    addIcon: {
      width: 21,
      height: 21,
    },
    imageTitle: {
      [mediaQuery(breakpoints.mobile)]: {
        '&.look-strong': {
          fontSize: 16,
        },
      },
    },
  }),
  {
    name: 'drag-and-drop-upload',
  },
);

export default useStyles;
